import React from 'react';
import { isEqual }  from 'lodash-es';
import { isValidCharacter } from '../../../utils';

export default (Form) => {
    return class extends React.Component {
        state = {
            initialValues: this.props.values,
            values: this.props.values,
        }

        static getDerivedStateFromProps(nextProps, prevState) {
            return !isEqual(nextProps.values, prevState.initialValues) ? { 
                values: nextProps.values,
                initialValues: nextProps.values,
            } : null;
        }

        handleChange = (e) => {
            if(isValidCharacter(e.target.name, e.target.value)){
                this.setState({
                    values: {
                        ...this.state.values,
                        [e.target.name]: e.target.value,
                    },
                });
            }
        }

        handleCleaveChange = (e) => {
            this.setState({
                values: {
                    ...this.state.values,
                    [e.target.name]: e.target.rawValue,
                },
            }); 
        }

        handleSubmit = (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.props.onSubmit(this.state.values);
        }

        render() {
            return (
                <Form {...this.props} values={this.state.values} handleChange={this.handleChange} handleCleaveChange={this.handleCleaveChange} onSubmit={this.handleSubmit} />
            )
        }
    }
}
